export const heroData = {
  title: "发现你的下一部\n最爱影视",
  subtitle: "海量高清电影、电视剧、综艺节目，随时随地在线观看",
  cta: "立即探索",
  secondaryCta: "了解我们",
  heroImageUrl: "https://readdy.ai/api/search-image?query=A%20cinematic%20movie%20theater%20interior%20with%20warm%20ambient%20lighting%20and%20rows%20of%20empty%20red%20velvet%20seats%20facing%20a%20giant%20glowing%20screen%20showing%20abstract%20colorful%20light%20patterns%2C%20luxurious%20atmosphere%20with%20soft%20shadows%20and%20golden%20accents%2C%20cinematic%20photography%20with%20dramatic%20depth%20of%20field&width=1600&height=900&seq=hero-bg-main&orientation=landscape",
};

export const categoryNav = [
  { slug: "movie", label: "电影", icon: "ri-movie-2-line", color: "bg-primary-500" },
  { slug: "tv", label: "电视剧", icon: "ri-tv-2-line", color: "bg-accent-500" },
  { slug: "variety", label: "综艺", icon: "ri-emotion-laugh-line", color: "bg-emerald-500" },
  { slug: "anime", label: "动漫", icon: "ri-rocket-2-line", color: "bg-violet-500" },
  { slug: "documentary", label: "纪录片", icon: "ri-earth-line", color: "bg-cyan-500" },
];

export const hotRecommendations = [
  {
    id: 1,
    title: "流浪地球3",
    category: "movie",
    categoryLabel: "电影",
    rating: 9.2,
    year: 2026,
    imageUrl: "https://readdy.ai/api/search-image?query=Epic%20Chinese%20sci-fi%20movie%20poster%20with%20massive%20planetary%20engines%20in%20space%2C%20dramatic%20lighting%20with%20warm%20orange%20glow%20against%20dark%20cosmic%20background%2C%20cinematic%20composition%20with%20grand%20scale%2C%20characters%20in%20futuristic%20space%20suits%2C%20movie%20poster%20style&width=400&height=560&seq=hot-rec-01&orientation=portrait",
    isHot: true,
    isNew: false,
  },
  {
    id: 2,
    title: "繁花似锦",
    category: "tv",
    categoryLabel: "电视剧",
    rating: 8.9,
    year: 2026,
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20poster%20set%20in%201990s%20Shanghai%2C%20elegant%20woman%20in%20vintage%20qipao%20dress%20standing%20on%20the%20Bund%20with%20city%20skyline%20at%20dusk%2C%20warm%20golden%20hour%20lighting%2C%20nostalgic%20atmosphere%2C%20soft%20film%20grain%20texture&width=400&height=560&seq=hot-rec-02&orientation=portrait",
    isHot: true,
    isNew: false,
  },
  {
    id: 3,
    title: "极限挑战第十季",
    category: "variety",
    categoryLabel: "综艺",
    rating: 8.7,
    year: 2026,
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20promotional%20poster%20with%20energetic%20hosts%20in%20colorful%20casual%20outfits%20posing%20dynamically%20against%20vibrant%20urban%20background%2C%20bright%20studio%20lighting%2C%20fun%20and%20playful%20atmosphere%2C%20entertainment%20show%20style&width=400&height=560&seq=hot-rec-03&orientation=portrait",
    isHot: true,
    isNew: false,
  },
  {
    id: 4,
    title: "深海传说",
    category: "anime",
    categoryLabel: "动漫",
    rating: 9.0,
    year: 2026,
    imageUrl: "https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20animation%20movie%20poster%20featuring%20a%20young%20girl%20diving%20into%20magical%20underwater%20world%20filled%20with%20glowing%20jellyfish%20and%20colorful%20coral%20reefs%2C%20dreamy%20bioluminescent%20lighting%2C%20Ghibli%20inspired%20art%20style%20with%20soft%20watercolor%20textures&width=400&height=560&seq=hot-rec-04&orientation=portrait",
    isHot: true,
    isNew: false,
  },
  {
    id: 5,
    title: "长安十二时辰2",
    category: "tv",
    categoryLabel: "电视剧",
    rating: 9.1,
    year: 2026,
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20historical%20suspense%20drama%20poster%20set%20in%20Tang%20Dynasty%20Changan%20city%2C%20detective%20character%20in%20traditional%20costume%20holding%20lantern%20in%20ancient%20street%20at%20night%2C%20atmospheric%20lighting%20with%20warm%20lantern%20glow%2C%20mysterious%20mood&width=400&height=560&seq=hot-rec-05&orientation=portrait",
    isHot: false,
    isNew: true,
  },
  {
    id: 6,
    title: "地球脉动第三季",
    category: "documentary",
    categoryLabel: "纪录片",
    rating: 9.5,
    year: 2026,
    imageUrl: "https://readdy.ai/api/search-image?query=Nature%20documentary%20poster%20showcasing%20diverse%20wildlife%20from%20arctic%20penguins%20to%20tropical%20rainforest%20creatures%20in%20beautiful%20composition%2C%20National%20Geographic%20photography%20style%2C%20rich%20vibrant%20colors%20with%20dramatic%20natural%20lighting&width=400&height=560&seq=hot-rec-06&orientation=portrait",
    isHot: false,
    isNew: true,
  },
  {
    id: 7,
    title: "无名之辈2",
    category: "movie",
    categoryLabel: "电影",
    rating: 8.5,
    year: 2026,
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20dark%20comedy%20movie%20poster%20featuring%20ordinary%20people%20from%20different%20social%20backgrounds%20in%20narrow%20alley%20of%20small%20city%2C%20realistic%20urban%20setting%20with%20warm%20street%20lamp%20lighting%2C%20slice%20of%20life%20aesthetic&width=400&height=560&seq=hot-rec-07&orientation=portrait",
    isHot: false,
    isNew: true,
  },
  {
    id: 8,
    title: "风起洛阳",
    category: "tv",
    categoryLabel: "电视剧",
    rating: 8.6,
    year: 2026,
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20historical%20mystery%20drama%20poster%20with%20ancient%20Luoyang%20city%20panorama%20at%20golden%20sunset%2C%20characters%20in%20elaborate%20Tang%20Dynasty%20costumes%20on%20grand%20palace%20steps%2C%20imperial%20architecture%20with%20flying%20eaves%2C%20epic%20scale&width=400&height=560&seq=hot-rec-08&orientation=portrait",
    isHot: false,
    isNew: false,
  },
];

export const latestReleases = [
  {
    id: 9,
    title: "星际穿越：重生",
    category: "movie",
    categoryLabel: "电影",
    rating: 8.8,
    year: 2026,
    imageUrl: "https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20movie%20poster%20showing%20astronaut%20floating%20near%20a%20massive%20wormhole%20with%20swirling%20light%20effects%2C%20stars%20and%20nebula%20in%20deep%20space%20background%2C%20dramatic%20cinematic%20lighting%20with%20blue%20and%20gold%20contrast%2C%20IMAX%20poster%20quality&width=400&height=560&seq=latest-01&orientation=portrait",
    isNew: true,
  },
  {
    id: 10,
    title: "我在他乡挺好的",
    category: "tv",
    categoryLabel: "电视剧",
    rating: 8.4,
    year: 2026,
    imageUrl: "https://readdy.ai/api/search-image?query=Contemporary%20Chinese%20urban%20drama%20poster%20showing%20young%20professionals%20walking%20through%20modern%20glass%20building%20lobby%20in%20Beijing%2C%20warm%20natural%20lighting%2C%20realistic%20slice%20of%20life%20aesthetic%2C%20emotional%20atmosphere&width=400&height=560&seq=latest-02&orientation=portrait",
    isNew: true,
  },
  {
    id: 11,
    title: "王牌对王牌第九季",
    category: "variety",
    categoryLabel: "综艺",
    rating: 8.3,
    year: 2026,
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20celebrity%20game%20show%20poster%20with%20hosts%20and%20guest%20stars%20in%20elegant%20formal%20wear%20posing%20on%20grand%20stage%20with%20golden%20decorations%2C%20bright%20entertainment%20lighting%2C%20luxurious%20variety%20show%20aesthetic&width=400&height=560&seq=latest-03&orientation=portrait",
    isNew: true,
  },
  {
    id: 12,
    title: "灵笼：终章",
    category: "anime",
    categoryLabel: "动漫",
    rating: 9.3,
    year: 2026,
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%203D%20sci-fi%20anime%20poster%20featuring%20armored%20warriors%20battling%20giant%20bioluminescent%20monsters%20in%20post-apocalyptic%20desolate%20landscape%2C%20dark%20atmospheric%20mood%20with%20neon%20accent%20lighting%2C%20epic%20action%20composition&width=400&height=560&seq=latest-04&orientation=portrait",
    isNew: true,
  },
  {
    id: 13,
    title: "舌尖上的中国第五季",
    category: "documentary",
    categoryLabel: "纪录片",
    rating: 9.1,
    year: 2026,
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20poster%20showcasing%20beautifully%20plated%20traditional%20Chinese%20dishes%20in%20artistic%20composition%2C%20warm%20appetizing%20lighting%20with%20steam%20effects%2C%20rich%20colors%20emphasizing%20fresh%20ingredients%2C%20culinary%20art%20photography&width=400&height=560&seq=latest-05&orientation=portrait",
    isNew: true,
  },
  {
    id: 14,
    title: "刺杀小说家2",
    category: "movie",
    categoryLabel: "电影",
    rating: 8.6,
    year: 2026,
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20fantasy%20action%20movie%20poster%20blending%20ancient%20mythology%20with%20modern%20urban%20setting%2C%20character%20wielding%20mysterious%20glowing%20weapon%20in%20rainy%20neon-lit%20city%20street%2C%20surreal%20atmosphere%20with%20blue%20and%20red%20contrast&width=400&height=560&seq=latest-06&orientation=portrait",
    isNew: true,
  },
];

export const latestArticles = [
  {
    id: 1,
    title: "2026年暑期档最值得期待的10部国产大片",
    excerpt: "今年暑期档可谓精彩纷呈，从科幻巨制到温情喜剧，国产电影正在以令人惊叹的速度崛起。我们为你精选了10部不容错过的佳作...",
    imageUrl: "https://readdy.ai/api/search-image?query=Cinematic%20poster%20collage%20featuring%20multiple%20Chinese%20blockbuster%20movie%20scenes%20in%20summer%202026%2C%20vibrant%20film%20strip%20arrangement%20with%20glowing%20theater%20atmosphere%2C%20rich%20warm%20colors%20with%20golden%20summer%20light&width=640&height=360&seq=article-card-01&orientation=landscape",
    date: "2026-08-10",
    readTime: 8,
    category: "电影资讯",
    tags: ["暑期档", "国产电影", "推荐"],
  },
  {
    id: 2,
    title: "《繁花似锦》为何成为今年现象级电视剧？",
    excerpt: "从剧本到表演，从服化道到音乐，《繁花似锦》在每一个细节上都展现出了极高的制作水准，成为观众茶余饭后的热议话题...",
    imageUrl: "https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20analysis%20of%20Chinese%20period%20drama%20with%20elegant%20vintage%20Shanghai%20aesthetic%2C%20film%20script%20and%20costume%20design%20sketches%20on%20wooden%20desk%20with%20warm%20lamp%20lighting%2C%20artistic%20editorial%20photography&width=640&height=360&seq=article-card-02&orientation=landscape",
    date: "2026-08-08",
    readTime: 12,
    category: "深度解析",
    tags: ["繁花似锦", "电视剧", "深度解析"],
  },
  {
    id: 3,
    title: "国产动漫崛起：从《灵笼》看中国动画的技术突破",
    excerpt: "中国动画产业正经历着前所未有的发展。《灵笼》系列的成功不仅证明了国产3D动画的技术实力，更展现了中国故事的独特魅力...",
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%203D%20animation%20studio%20environment%20with%20computer%20screens%20showing%20character%20models%20and%20scene%20renders%2C%20futuristic%20anime%20art%20style%20posters%20on%20walls%2C%20blue%20ambient%20tech%20lighting%2C%20creative%20workspace%20atmosphere&width=640&height=360&seq=article-card-03&orientation=landscape",
    date: "2026-08-05",
    readTime: 10,
    category: "行业观察",
    tags: ["国产动漫", "灵笼", "技术"],
  },
  {
    id: 4,
    title: "纪录片推荐：五部让你重新认识世界的优秀作品",
    excerpt: "一部好的纪录片就像一扇窗，让我们得以窥见世界的不同面貌。以下是五部近期不容错过的优秀纪录片...",
    imageUrl: "https://readdy.ai/api/search-image?query=Curated%20collection%20of%20nature%20and%20culture%20documentary%20stills%20in%20elegant%20gallery%20wall%20layout%2C%20diverse%20scenes%20from%20wildlife%20to%20ancient%20civilizations%2C%20warm%20museum%20lighting%2C%20sophisticated%20editorial%20design&width=640&height=360&seq=article-card-04&orientation=landscape",
    date: "2026-08-01",
    readTime: 7,
    category: "影评推荐",
    tags: ["纪录片", "推荐", "自然"],
  },
];

export const sectionBackgroundUrl = "https://readdy.ai/api/search-image?query=Abstract%20cinematic%20background%20with%20soft%20gradients%20of%20warm%20peach%20and%20cream%20tones%2C%20subtle%20film%20grain%20texture%20overlay%2C%20gentle%20bokeh%20light%20effects%2C%20elegant%20and%20minimalist%20design%20for%20movie%20platform%20website%20section%20background&width=1600&height=900&seq=section-bg-01&orientation=landscape";